module.exports = __webpack_public_path__ + "static/steven-curtis-chapman.46ee73a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/steven-curtis-chapman.jpg
// module id = 1323
// module chunks = 168707334958949